import {
    isString,
    isFunction,
    isObject,
    deepMixin
} from "../funcs";
import Events from "../classes/Events";
import DragModal from "../classes/modals/DragModal";
import Loader from "../classes/Loader";
import langDictionary from "../classes/lang/init";


// что есть приложение?
// это точка входа, у которой есть $элемент для отрисовки компонентов
//
// приложения открываются из меню или рабочего стола

const appsBySingleKey = {};
export default class BaseApp extends Events {

    constructor(params, callback) {
        super();
        this.init(params, callback);
    }

    init(params, callback) {

        if ( !isFunction(callback) ) {
            callback = function() {};
        }
        deepMixin({}, params);
        this.params = params;

        // запрещаем открывать приложение повторно
        if ( params.single || this.single === true || isFunction(this.single) ) {
            let singleKey = this._getSingleKey();


            let existsApp = appsBySingleKey[ singleKey ];

            // костыль, приложение залагало
            if ( existsApp && existsApp.modal && !existsApp.modal.$[0].parentNode ) {
                try {
                    existsApp.destroy();
                } catch (e) {
                    console.error(e);
                }
                existsApp = false;
            }

            if ( existsApp ) {
                existsApp.show();
                callback(existsApp);
                return;
            }

            appsBySingleKey[ singleKey ] = this;
        }


        window.app = this;// for debug

        this.initChannel();


        if ( this.modal ) {
            this.initModal();
            this.modal.show();
            this.modal.$.addClass("loading transition-size");
            this.loader.start();
        }

        this._preloading = true;
        this.preload(params, (err) => {
            if ( err ) {
                this._preloading = false;
                if ( this.modal ) {
                    this.modal.$.hide();
                }
                return;
            }

            if ( this.modal ) {
                setTimeout(() => {
                    this.loader.stop();
                }, 100);
                this.modal.setTitle(this.getModalTitle());
                if ( params.full === true ) {
                    this.modal.full();
                } else if ( !this.modal.isFull ) {
                    this.modal.setSize({
                        center: true,
                        width: this.params.width,
                        height: this.params.height
                    });
                }

                this.modal.$.removeClass("loading transition-size");
            }

            params = this.params;

            this.onReady(params);
            callback(this);

            this._preloading = false;
        });

        this.listenTo(system, "lang:other:change lang:texts:change", () => {
            if ( this.modal ) {
                const newTitle = this.getModalTitle();
                this.modal.setTitle(newTitle);
            }
        });
    }

    initChannel() {
        let channel = system.apps.channel(this.params.type); /// !!!!!!!!!!!!!!!!!!!!!!!!!! @see AppManager

        if ( isFunction(this.channelEvents) ) {
            this.channelEvents = this.channelEvents();
        }
        else {
            this.channelEvents = {};
        }

        for (let key in this.channelEvents) {
            let method = this.channelEvents[key];

            if ( isString(method) ) {
                method = this[method];
            }

            this.listenTo(channel, key, method.bind(this));
        }
        this.channel = channel;
    }

    initModal() {
        if ( !this.modal ) {
            return;
        }
        this.modal = this.modal();

        let modalParams = this.params;


        let CustomModal = DragModal;
        if ( isObject(this.modal) ) {
            modalParams = deepMixin(this.modal, modalParams);
        }
        else if ( isFunction(this.modal) ) {
            CustomModal = this.modal;
        }

        modalParams = deepMixin({
        }, modalParams);

        this.modal = new CustomModal(modalParams);

        this.$box = this.modal.$box;
        this.$box.css({
            padding: 0
        });
        this.box = this.$box.get(0);
        this.title = langDictionary.get(modalParams.title);
        this.$box.addClass(this.constructor.className);

        if ( modalParams.full !== false ) {
            this.modal.full();
        }

        this.listenTo(this.modal, "*", (...args) => {
            const name = args[0];

            if ( name == "resize" || name == "destroy" ) {
                return;
            }
            this.trigger.apply(this, args);
        });

        this.modal.hide = this.destroy.bind(this);

        this.listenTo(this.modal, "show", (...args) => {
            if ( this._preloading ) {
                return;
            }
            this.onShow.apply(this, args);
        });

        this.listenTo(this.modal, "resize full unfull", () => {
            if ( this._preloading ) {
                return;
            }
            let {width, height} = this.modal;
            let modalSize = { width, height };
            let boxSize = this.modal.getBoxSize();
            this.onResize.call(this, modalSize, boxSize);
        });

        this.listenTo(this.modal, "full", (...args) => {
            if ( this._preloading ) {
                return;
            }
            this.onFull.apply(this, args);
        });

        this.listenTo(this.modal, "zup", () => {
            window.app = this; // for debug
        });

        this.listenTo(this.modal, "resize show full unfull move", (...args) => {
            if ( this._preloading ) {
                return;
            }
            this.onMove.apply(this, args);
        });

        this.listenTo(this.modal, "resizeEnd", (...args) => {
            if ( this._preloading ) {
                return;
            }
            this.onResizeEnd.apply(this, args);
        });

        this.loader = new Loader({
            box: this.box
        });
    }

    preload(params, callback) {callback(null);}
    onReady(/* params */) {}

    onResize() {}
    onResizeEnd() {}
    onMove() {}
    onShow() {}
    onFull() {}

    // redefine me
    getModalTitle() {
        return this.params.title;
    }

    // по умолчанию, по закрытию модалки (крестик) мы уничтожаем приложение
    destroy(options) {
        let onDestroyResult = true;
        try {
            onDestroyResult = this.onDestroy(options); // например разрушение грида
        } catch (e) {
            console.error(e);
        }

        if ( onDestroyResult === false ) {
            return false;
        }

        if ( this.modal && isFunction(this.modal.destroy) ) {
            try {
                this.modal.destroy(options);
            } catch (e) {
                console.error(e);
            }
        }

        this.trigger("destroy");
        this.clearEvents();
        if ( this.params ) {
            delete appsBySingleKey[ this._getSingleKey() ];
        }

        if ( window.app == this ) {
            delete window.app;
        }

        // @see AppManager.js
        // @see MainMenu.js
        if ( this.params.runName === localStorage.getItem("lastRun") ) {
            localStorage.removeItem("lastRun");
        }
    }
    onDestroy() {}

    show() {
        if ( this.modal ) {
            this.modal.upMyZIndex();
            this.modal.show();
        }
    }

    // dynamic singleton
    _getSingleKey() {
        if ( !this.params ) {
            throw new Error("return me params!");
        }

        if ( isFunction(this.params.single) ) {
            return this.constructor.className + "." + this.params.single.call(this, this.params);
        }

        if ( isFunction(this.single) ) {
            return this.constructor.className + "." + this.single(this.params);
        }

        return this.params.single
            ? this.constructor.className + "." + this.params.single
            : this.constructor.className;
    }
}
